<template>
  <pt-lab-order-form class="pt-lab-order-form__page"></pt-lab-order-form>
</template>

<script>
import PtLabOrderForm from 'cps/lab-order/pt-lab-order-form/withData'
export default {
  name: 'pt-lab-order-form__view',
  components: {
    'pt-lab-order-form': PtLabOrderForm
  }
}
</script>
